export default __webpack_public_path__ + "a42890a.png";